// extracted by mini-css-extract-plugin
export default {"fieldWrapper":"delete-confirm-reason-modal_fieldWrapper__bFSQk","required":"delete-confirm-reason-modal_required__mPHSW"};